import './App.scss';

import AppRoutes from './routes';
import Notification from './components/Notification';
import ProgressBar from './components/ProgressBar';
import React from 'react';
import ErrorHandler from './ErrorHandler';

// Suppress Chrome ResizeObserver loop error
const resizeObserverErr = /ResizeObserver loop completed/;
const originalError = console.error;

console.error = (...args) => {
  if (args[0] && resizeObserverErr.test(args[0])) {
    return; // ignore this specific error
  }
  originalError.apply(console, args);
};

function App() {
  return (
    <div className="app">
      <ErrorHandler>
        <Notification />
        <AppRoutes />
        <ProgressBar />
      </ErrorHandler>
    </div>
  );
}

export default App;
